import type { Feature } from '@luna/gatekeeper';

export const limitsChange: Feature = {
    enabled: false,
    _description: 'Enables display of the refactored limit change focus page',
};
